// eslint-disable-next-line import/prefer-default-export
export const REACTION_RELAY_TYPES = {
  REACTION: 'react',
} as const;
